module.exports = __webpack_public_path__ + "static/media/V-Passport web add editables-03.48b0dcfd.png";